import { baseApi } from './base-api'

export const authApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    login: build.mutation<any, any>({
      query: (body) => ({
        url: '/auth',
        method: 'post',
        body: body
      }),
    }),
    requestPasswordReset: build.mutation<any, { email: string }>({
      query: (body) => ({
        url: '/auth/requestReset',
        method: 'post',
        body: body
      }),
    }),

    resetPassword: build.mutation<any, { email: string; code: string; newPassword: string }>({
      query: (body) => ({
        url: '/auth/resetPassword',
        method: 'post',
        body: body
      }),
    }),
    resetPasswordWithCurrent: build.mutation<any, { email: string; currentPassword: string; newPassword: string }>({
      query: (body) => ({
        url: '/auth/resetPasswordWithCurrent',
        method: 'post',
        body: body
      }),
    }),

  }),
  overrideExisting: true,
})

export const { 
  useLoginMutation,
  useRequestPasswordResetMutation,
  useResetPasswordMutation
} = authApi